module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "patientInfoPanel"
  }, [_c('p', {
    staticClass: "patient-name-label"
  }, [_vm._v("患者姓名:" + _vm._s(_vm.orderDetail.demPatient))]), _vm._v(" "), _c('p', {
    staticClass: "patient-name-label"
  }, [_vm._v("更新日期:" + _vm._s(_vm.orderDetail.updateTime))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fixed-bottom"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "padding-right": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedLower),
      expression: "checkedLower"
    }],
    attrs: {
      "type": "checkbox",
      "id": "cb-lower"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedLower) ? _vm._i(_vm.checkedLower, null) > -1 : (_vm.checkedLower)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkedLower,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedLower = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedLower = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedLower = $$c
        }
      }, _vm.enableMeshButtons]
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-right": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedUpper),
      expression: "checkedUpper"
    }],
    attrs: {
      "type": "checkbox",
      "id": "cb-upper"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedUpper) ? _vm._i(_vm.checkedUpper, null) > -1 : (_vm.checkedUpper)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkedUpper,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedUpper = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedUpper = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedUpper = $$c
        }
      }, _vm.enableMeshButtons]
    }
  }), _vm._v(" "), _vm._m(2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0px",
      "position": "relative",
      "border-bottom": "1px solid #9d9d9d"
    }
  }, [_c('div', {
    staticClass: "webviewer-header",
    staticStyle: {
      "position": "relative"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "clinic_log_iamge",
    attrs: {
      "src": require("../../../static/images/user_normal.png"),
      "height": "40"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "viewer_logo_image",
    attrs: {
      "src": require("../../../static/images/global-logo-red.png"),
      "height": "60"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "catalog-button-label",
    attrs: {
      "for": "cb-lower"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/lower_normal.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "catalog-button-label",
    attrs: {
      "for": "cb-upper"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/upper_normal.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b679113","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/3Dmodel.vue
// module id = 627
// module chunks = 0